import config from "./config";
import APIService from "./api-service";
import objectToQueryParams from "../common/objectToQueryParams";

/**
 * @param {String} email
 * @param  {String} password
 * @param {String} type
 */

export default class LenderUgroService extends APIService {
  static getEligibleNonEligibleUsers({ type, leadId, responseType, option }) {
    if (option) {
      return this.get(
        `${config.baseUrl[type]}/co-lender/lead/matched/${leadId}/${option}`,
        null,
        responseType
      );
    } else {
      return this.get(
        `${config.baseUrl[type]}/co-lender/lead/matched/${leadId}`,
        null,
        responseType
      );
    }
  }
  static checkLendingDetails({ type, requestBody }) {
    return this.post(
      `${config.baseUrl[type]}/co-lender/lead/lender-eligibility`,
      requestBody
    );
  }
  static getFilteredPortfolio({
    type,
    leadType,
    page,
    dataExport,
    queryParams,
    responseType,
    sortOrder,
    sortBy,
    isOps
  }) {
    return this.get(
      `${config.baseUrl[type]}${isOps && '/ops'}/leads/${leadType}?page=${page}&export=${dataExport}&${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
    }${sortBy ? `&sort_by=${sortBy}` : ""}`,
      null,
      responseType
    );
  }

  static getAdminFilteredPortfolio({
    type,
    leadType,
    page,
    dataExport,
    queryParams,
    responseType,
    sortOrder,
    sortBy,
    isOps,
  }) {
    let path;
    // if(!queryParams){
    //   path=`${config.baseUrl[type]}/${isOps ? "ops" : "co-lender"
    // }/leads/${leadType}?export=${dataExport}&page=1${sortOrder ? `&sort_order=${sortOrder}` : ""
    // }${sortBy ? `&sort_by=${sortBy}` : ""}`
    // }else{
    //   path=`${config.baseUrl[type]}/${isOps ? "ops" : "co-lender"
    // }/leads/${leadType}?export=${dataExport}&${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
    // }${sortBy ? `&sort_by=${sortBy}` : ""}`
    // }
    path=`${config.baseUrl[type]}/${isOps ? "ops" : "co-lender"
    }/leads/${leadType}?page=${page}&export=${dataExport}&${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
    }${sortBy ? `&sort_by=${sortBy}` : ""}`
    return this.get(
      path,
      null,
      responseType
    );
  }

  static downloadMisReport({
    type,
    leadType,
    page,
    dataExport,
    queryParams,
    responseType,
    sortOrder,
    sortBy,
    isOps,
    endPoint
  }) {
    return this.get(
      `${config.baseUrl[type]}/${isOps ? "ops" : "co-lender"
      }/leads/report/${endPoint}`, null,
      responseType
    );
  }

  static downloadMisReportNew({
    type,
    leadType,
    page,
    dataExport,
    queryParams,
    responseType,
    sortOrder,
    sortBy,
    isOps,
    endPoint,
    payloadData
  }) {
    return this.post(
      `${config.baseUrl[type]}/leads/report/${endPoint}`, payloadData, null, null
      // responseType
    );
  }

  static getDownloadsHistory({ type, endPoint }) {
    return this.get(
      `${config.baseUrl[type]}/leads/report/${endPoint}`
    );
  }

  static downloadFileById({ type, fileId, responseType }) {
    return this.get(
      `${config.baseUrl[type]}/doc/download?file_id=${fileId}`, null, responseType
    );
  }

  static downloadLink({ type, identifier, responseType }) {
    return this.get(
      `${config.baseUrl[type]}/download-only-once?identifier=${identifier}`, null, responseType
    );
  }

  static getPortfolioDetail({ type, leadId, lenderId }) {
    return this.get(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/lead/detail" : "lead"
      }/${leadId}${type === "admin" ? "/" + lenderId : ""}`
    );
  }
  static getPortfolioNewDetail({ type, leadId }) {
    return this.get(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/lead/detail-info" : "lead/detail-info"
      }/${leadId}`
    );
  }

  static getLeadDetailInfo({ type, leadId }) {
    return this.get(`${config.baseUrl[type]}/${"lead"}/${leadId}`);
  }
  static getPortfolioDocuments({ type, leadId, lenderId }) {
    return this.get(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/" : ""
      }lead/documents/${leadId}${type === "admin" ? `/${lenderId ? lenderId : 0}` : ""}`
    );
  }

  static getOTCDocuments({ type, leadId, lenderId }) {
    return this.get(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/" : ""
      }lead/otc-documents/${leadId}${type === "admin" ? `/${lenderId ? lenderId : 0}` : ""}`
    );
  }

  static approveLead({ type, requestBody }) {
    return this.post(`${config.baseUrl[type]}/leads/approve`, requestBody);
  }

  static rejectLead({ type, requestBody }) {
    return this.post(`${config.baseUrl[type]}/leads/reject`, requestBody);
  }

  static addLeadQuery(type, formData, subType) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(
      `${url}/lead/save-colender-lead-query`,
      formData,
      null,
      null,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  }

  static getCoLenders({ type, leadId }) {
    let url = `${config.baseUrl[type]}`;
    if (type === "admin") {
      url += `/co-lender`;
    }
    return this.get(
      `${url}/lead/get-colender-lead-assign?cl_lead_id=${leadId}`
    );
  }
  static getLenderUsers({ type, leadId }) {
    return this.get(
      `${config.baseUrl[type]}/get-assign-lender-users/${leadId}`
    );
  }

  static assignLender({ type, requestBody }) {
    return this.post(
      `${config.baseUrl[type]}/co-lender/lead/assign-colender-lead`,
      requestBody
    );
  }
  static assignUserLead({ type, requestBody }) {
    return this.get(
      `${config.baseUrl[type]}/lead/assign-to-lender-user/${requestBody.cl_lead_id}/${requestBody.user_id}`
    );
  }
  static addAdditionalInformation({
    type,
    leadId,
    lenderId,
    infoId,
    requestBody,
  }) {
    return this.post(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/" : ""
      }lead/save-additional-info?cl_lead_id=${leadId}${lenderId && type == "admin" ? "&lender_id=" + lenderId : ""
      }`,
      requestBody
    );
  }
  static getAdditionalInformation({ type, params }) {
    return this.get(
      `${config.baseUrl[type]}/${type === "admin" ? "co-lender/" : ""
      }lead/get-additional-info?${objectToQueryParams(params)}`
    );
  }
  static getQueryDetails({ type, isChild, params }) {
    if (isChild)
      return this.get(
        `${config.baseUrl[type]}${type === "admin" ? "/co-lender" : ""
        }/lead/get-colender-child-lead-query/${isChild}`
      );
    return this.get(
      `${config.baseUrl[type]}${type === "admin" ? "/co-lender" : ""
      }/lead/get-colender-lead-query?${objectToQueryParams(params)}`
    );
  }

  static getPaymentToken(requestBody) {
    return this.post(
      "https://bob-api-uat.knightfintech.com/GetToken",
      requestBody,
      null,
      null,
      {},
      false
    );
  }

  static getPaymentList(leadId) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/repayment-detail/${leadId}`
    );
  }

  static getRePaymentList({ leadId, lenderId }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/get-repayment/${leadId}/${lenderId}`
    );
  }

  static getLenderRePaymentList({ leadId, lenderId }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/get-lender-repayment-schedule/${leadId}/${lenderId}`
    );
  }

  static fetchRePaymentList(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/lead/fetch-repayment`, payloadData
    );
  }

  static downloadRepaymentFile({ type, leadId, lenderId, dataExport, responseType }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/get-repayment/${leadId}/${lenderId}?export=${dataExport}&type=${type}`, null, responseType
    );
  }

  static downloadLenderRepaymentFile({ type, leadId, lenderId, dataExport, responseType }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/get-lender-repayment-schedule/${leadId}/${lenderId}?export=${dataExport}&type=${type}`, null, responseType
    );
  }

  static getbulkfundoutList(page, heading, queryParams, lenderId=null) {
    if (heading === "operations") {
      heading = "ops";
    }
    if (heading === "utr") {
      heading = "fundout";
    }
    if(heading === "collection"){
      return this.get(
        `${config.baseUrl["admin"]}/co-lender/lead/${heading}/upload-list/${lenderId}?page=${page}&${queryParams}`
      );
    }else{
      return this.get(
        `${config.baseUrl["admin"]}/co-lender/lead/${heading}/upload-list?page=${page}&${queryParams}`
      );
    }
  }

  static getListOfPendingQueries({page, queryParams, exportCount,sortOrder,sortBy}) {
    if (exportCount == 1) {
      let responseType = "blob"
      return this.get(
        `${config.baseUrl["admin"]}/co-lender/leads/pending-query-list?page=${page}&${queryParams}&export=${exportCount}${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
      }${sortBy ? `&sort_by=${sortBy}` : ""}`, null, responseType
      )
    }
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/leads/pending-query-list?page=${page}&${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
    }${sortBy ? `&sort_by=${sortBy}` : ""}`
    );
  }


  static resolveQuery(type, formData) {
    return this.post(
      `${config.baseUrl[type]}/co-lender/lead/save-colender-lead-query`,
      formData,
      null,
      null,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  }

  static updateDocPassword(type, data, subType) {
    return this.post(
      `${config.baseUrl[type]}/${subType ? subType + "/" : ""
      }lead/document/update`,
      data
    );
  }
  static reportInfoUpdate(type, data, subType) {
    return this.post(
      `${config.baseUrl[type]}/${subType ? subType + "/" : ""
      }lead/document/update/report-info`,
      data
    );
  }

  /**
   *
   * @param {string} type
   * @param {string} subType
   * @param {string} docId
   */
  static downloadDocFile(type, subType, docId) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/lead/document/download?lead_doc_file_id=${docId}`,
      null,
      "blob"
    );
  }

  /**
   *
   * @param {string} type
   * @param {string} subType
   * @param {string} docId
   */
  static downloadAttachmentFile(type, subType, docId) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }

    return this.get(
      `${url}/lead/query/document/download/${docId}`,
      null,
      "blob"
    );
  }

  /**
   *
   * @param {string} type
   * @param {string} subType
   * @param {string} leadId
   * @param {*} body
   */
  static getLeadDemand(type, subType, leadId, body) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/get-demand/${leadId}`, body);
  }

  /**
   *
   * @param {string} type
   * @param {string} subType
   * @param {*} body
   */
  static toggleDocumentForLender(type, subType, body) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/documents/submit-to-lender`, body);
  }
  /**
   *
   * @param {string} type
   * @param {string} subType
   * @param {string} leadId
   * @param {*} body
   */
  static postLeadDemand(type, subType, leadId, body) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/post-demand/${leadId}`, body);
  }

  /**
   *
   * @param {*} type
   * @param {*} subType
   * @param {*} leadId
   */
  static submitToLender(type, subType, leadId, detailLenderId, otp=null, gstUsername=null) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/submit-to-lender/${leadId}/${detailLenderId}?otp=${otp}&gst_username=${gstUsername}`);
  }

  /**
   *
   * @param {*} type
   * @param {*} subType
   * @param {*} leadId
   */
  static jocataSendOTP(type, subType, leadId, detailLenderId, gstUsername, isValidate) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/jocata-send-otp/${leadId}/${detailLenderId}?gst_username=${gstUsername}&type=${isValidate}`);
  }

  /**
   *
   * @param {*} type
   * @param {*} subType
   * @param {*} leadId
   */
  static Sanction_changeStatus(type, leadId) {
    let url = config.baseUrl[type];
    return this.post(`${url}/ops/lead/change-status`, {
      lead_id: leadId,
    });
  }

  static disbursedChangeStatus(type, leadId, lenderId) {
    let url = config.baseUrl[type];
    return this.post(`${url}/ops/lead/change-disbursed-status`, {
      lead_id: leadId,
      lender_id: lenderId,
    });
  }

  static dpwotcChangeStatus(type, leadId, docIds, comment) {
    let url = config.baseUrl[type];
    return this.post(`${url}/ops/lead/change-dpwotc-status`, {
      lead_id: leadId,
      doc_ids: docIds,
      comment:comment
    });
  }
  /**
 *
 * @param {*} type
 * @param {*} subType
 * @param {*} leadId
 */
  static PreSanctionSubmitToLender(type, subType, leadId, detailLenderId) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/submit-to-lender-pre-sanction/${leadId}/${detailLenderId}`);
  }
  /**
   *
   * @param {*} type
   * @param {*} subType
   * @param {*} leadId
   */
  static pullBackLead(type, subType, leadId, lenderId, comment) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/pull-back/${leadId}`, {
      lender_ids: lenderId,
      message: comment,
    });
  }

  static getDashboardLenderPortfolio(prodId, date) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/dashboard/lender-portfolio?prod_type_id=${prodId}&date=${date}`
    );
  }

  static getDashboardLenderBar(type, subType, barType, prodId) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio/${barType}?prod_type_id=${prodId}`
    );
  }

  static getDashboardTotalAssigned(type, subType, prodId, lenderId) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/total-assigned-portfolio?${lenderId ? "lender_id=" + lenderId + "&" : ""
      }prod_type_id=${prodId}`
    );
  }

  static getDashboardLenderPerformance(prodId, date) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/dashboard/lender-performance?prod_type_id=${prodId}&date=${date}`
    );
  }
  static getLeadAuditTrail(leadId, lenderId, leadType) {
    return this.get(
      `${config.baseUrl["admin"]}/get-audit-trail/${leadId}/${lenderId}?lead_type=${leadType}`
    );
  }

  static fetchDocuments(leadId) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/document/fetch-dms-document/${leadId}`
    );
  }

  static bulkLeadSubmit({ leadIds, lenderId, comment }) {
    let body = {
      cl_lead_ids: leadIds,
      lender_id: lenderId,
      comment: comment,
    };
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/lead/bulk-submit-lead`,
      body
    );
  }
  static getLeadAuditTrailHistory({ page, queryParams }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/bulk-submit-audit-trail?page=${page}&${queryParams}`
    );
  }

  /**
   *
   * @param {*} batchId
   *
   */
  static getLeadAuditTrailByBatch({ page, batchId }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/bulk-submit-audit-trail/${batchId}?page=${page}`
    );
  }
  static dashboardTotalAssignedPortfolio({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio?${objectToQueryParams(params)}`
    );
  }
  static dashboardLenderPending({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio/lender-pending-portfolio1?${objectToQueryParams(
        params
      )}`
    );
  }
  static dashboardLenderPending2({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio/lender-pending-portfolio2?${objectToQueryParams(
        params
      )}`
    );
  }
  static dashboardLenderPending3({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio/lender-pending-portfolio3?${objectToQueryParams(
        params
      )}`
    );
  }
  static dashboardUnassignedPortfolio({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/leads/unassigned?${objectToQueryParams(params)}`
    );
  }
  static dashboardFinallyAssignedPortfolio({ type, params, subType }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(
      `${url}/dashboard/lender-portfolio/finally-assigned?${objectToQueryParams(
        params
      )}`
    );
  }

  /**
   *
   * @param {string} type
   * @param {object} body
   * @returns Promise
   */
  static approveOpsLead(type, body) {
    let url = config.baseUrl[type];

    return this.post(`${url}/lead/disbursal/approve`, body);
  }

  /**
   *
   * @param {string} type
   * @param {object} body
   * @returns Promise
   */
  static modifyLeadOpsStatus(type, body) {
    let url = config.baseUrl[type];

    return this.post(`${url}/lead/disbursal/change-status`, body, null, null, {
      "Content-Type": "multipart/form-data",
    });
  }

  /**
   *
   * @param {*} type
   * @param {*} formData
   * @param {*} subType
   * @returns
   */
  static addRepaymentDoc(type, formData, subType) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/repayment/submit`, formData, null, null, {
      "Content-Type": "multipart/form-data",
    });
  }
  static bulkfundoutupload(type, formData, subType, heading, lenderId=null) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    if (heading === "utr") {
      return this.post(`${url}/lead/fundout/bulk-upload`, formData, null, null, {
        "Content-Type": "multipart/form-data",
      });
    } else if (heading === "collection"){
      return this.post(`${url}/lead/upload-collections/${lenderId}`, formData, null, null, {
        "Content-Type": "multipart/form-data",
      });
    } else if (['credit', 'operations', 'cersai', 'machinery', 'lap', 'collateral'].includes(heading)) {
      return this.post(`${url}/lead/more-info/bulk-upload`, formData, null, null, {
        "Content-Type": "multipart/form-data",
      });
    }
  }

  static getsamplefile({ type, subType, responseType, heading, lenderId }) {
    if (heading === "operations") {
      heading = "ops";
    } else if (heading === "utr") {
      heading = "fundout";
    } else if (["credit", "cersai", "machinery", "lap", "collateral", "collection"].includes(heading)) {
      heading = heading;
    } else {
      heading = ""
    }
    let url = `${config.baseUrl["admin"]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/sample-doc/download?type=${heading}&lenderId=${lenderId}`, null, responseType);
  }

  static getUTRDetails({ type, subType, leadId }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/utr/${leadId}`);
  }
  /**
  *
  * @param {*} type
  * @param {*} formData
  * @param {*} subType
  * @param {*} lenderId
  * @returns
  */
  static getFundoutDetail({ lender_id, type, subType, leadId }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/fundout/${leadId}/${lender_id}`);
  }
  /**
   *
   * @param {string} type
   * @param {object} body
   * @returns Promise
   */
  static addUTRInfo({ type, subType, formData }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/utr/submit`, formData, null, null, {
      "Content-Type": "multipart/form-data",
    });
  }
  static addFundout({ type, subType, formData }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
      // console.log(formData);
    }
    return this.post(`${url}/lead/fundout/save`, formData, null, null, {
      "Content-Type": "multipart/form-data",
    });
  }

  static getMandateDetail({ lender_id, type, subType, leadId }) {
    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/mandate/${leadId}/${lender_id}`);
  }

  static addMandate({ type, subType, formData }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/mandate/save`, formData, null, null, {
      "Content-Type": "multipart/form-data",
    });
  }

  /**
 *
 * @param {string} type
 * @param {object} body
 * @returns Promise
 */
  static ConditionalApprove({ type, subType, formData }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/pre-sanction-params/submit`, formData, null, null, {
      'Content-Type': 'multipart/form-data',
    });
  }

  /**
 *
 * @param {string} type
 * @param {object} body
 * @returns Promise
 */
  static conditionSanction_approve({ type, subType, formData }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.post(`${url}/lead/pre-sanction-params/verify`, formData, null, null, {
      'Content-Type': 'multipart/form-data',
    });
  }

  /**
   *
   * @param {string} type
   * @param {object} body
   * @returns Promise
   */
  static SaveDrfDetail({ formData, leadId, lenderId }) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/lead/drf/${leadId}/${lenderId}`,
      formData,
      null,
      null,
      {
        "Content-Type": "multipart/form-data",
      }
    );
  }

  static changeDrfStatus({ formData, leadId, lenderId }) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/lead/change-drf-status/${leadId}/${lenderId}`,
      formData,
      null,
      null,
      null,
    );
  }

  /**
   *
   * @param {string} type
   * @param {object} body
   * @returns Promise
   */
  static getUserList({ type, page, queryParams, exportList }) {
    let url = config.baseUrl[type];

    return this.get(
      `${url}/backend-user?page=${page}&${queryParams}&export=${exportList ? 1 : 0
      }`,
      null,
      exportList ? "blob" : "json"
    );
  }

  static getConditionalApproveDetail({ type, subType, leadId, lenderId }) {

    let url = `${config.baseUrl[type]}`;
    if (subType) {
      url += `/${subType}`;
    }

    return this.get(`${url}/lead/pre-sanction-params/${leadId}/${lenderId}`);
    // return this.get(`${url}/lead/pre-sanction-params/lead/pre-sanction-params/2429/1`);
  }

  static changeQueryStatus({ type, subType, queryId }) {
    let url = config.baseUrl[type];
    if (subType) {
      url += `/${subType}`;
    }
    return this.get(`${url}/lead/change-lead-query-status/${queryId}`);
  }

  static getApiLogList({ type, lender_id, laf_id, lead_id, application_id, lead_type, assigned_date_from, assigned_date_to, created_date_from, created_date_to, response_status, los_source, page }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/api-response-list?lender_id=${lender_id}${laf_id ? `&laf_id=${laf_id}` : ''}${lead_id ? `&lead_id=${lead_id}` : ''}${application_id ? `&application_id=${application_id}` : ''}${lead_type ? `&lead_type=${lead_type}` : ''}${assigned_date_from ? `&assigned_date_from=${assigned_date_from}` : ''}${assigned_date_to ? `&assigned_date_to=${assigned_date_to}` : ''}${created_date_from ? `&created_date_from=${created_date_from}` : ''}${created_date_to ? `&created_date_to=${created_date_to}` : ''}${response_status ? `&response_status=${response_status}` : ''}${los_source ? `&los_source=${los_source}` : ''}&page=${page}`);
  }
  static exportApiLogList({ type, lender_id, laf_id, lead_id, application_id, lead_type, assigned_date_from, assigned_date_to, response_status, page }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/api-response-list?lender_id=${lender_id}${laf_id ? `&laf_id=${laf_id}` : ''}${lead_id ? `&lead_id=${lead_id}` : ''}${application_id ? `&application_id=${application_id}` : ''}${lead_type ? `&lead_type=${lead_type}` : ''}${assigned_date_from ? `&assigned_date_from=${assigned_date_from}` : ''}${assigned_date_to ? `&assigned_date_to=${assigned_date_to}` : ''}${response_status ? `&response_status=${response_status}` : ''}&page=${page}&export=1`, null, "blob");
  }
  static getApiLogResponses({ type, cl_lead_id, cl_lender_id,lead_type }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/api-response-data/${cl_lead_id}/${cl_lender_id}?lead_type=${lead_type}`);
  }

  static getApiCollectionLogResponses({ type, cl_lead_id, cl_lender_id,lead_type }) {
    return this.get(`${config.baseUrl[type]}/co-lender/lead/collection/api-logs-data/${cl_lead_id}/${cl_lender_id}?lead_type=${lead_type}`);
  }

  static retryFailedApiLogResponses({ type, cl_lead_id, cl_lender_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/logs-resubmit-lead/${cl_lead_id}/${cl_lender_id}`);
  }

  static getGlobalSearchList({
    type,
    laf_id
  }) {
    return this.get(`${config.baseUrl[type]}/co-lender/leads/search?laf_id=${laf_id}`)
  }

  static getStatusApilogs({ type, cl_lead_id, cl_lender_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/logs-refetch-status/${cl_lead_id}/${cl_lender_id}`);
  }

  static shareAllDocumentsAtOnce(formData) {
    return this.post(`${config.baseUrl['admin']}/co-lender/lead/documents/check-documents`, formData, null,
      null,
      {
        "Content-Type": "multipart/form-data",
      });
  }

  static getRepaymentDetails({ type, cl_lead_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/lead/get-rps-detail/${cl_lead_id}`);
  }

  static getDALovMasterList() {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/filter-master-list`
    );
  }
  static getFilteredDaList({ page, parsedData, sortOrder, sortBy, dataExport, responseType }) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/da-filter-list?page=${page}${sortOrder ? `&sort_order=${sortOrder}` : ""
      }${sortBy ? `&sort_by=${sortBy}` : ""}&export=${dataExport ? dataExport : 0}`, parsedData, null, responseType
    );
  }
  static createBatch(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/create-batch`, payloadData
    );
  }
  static getBatchList({ per_page, page }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/da-batch-list?per_page=${per_page}&page=${page}`);
  }
  static getBatchListByBatchId({ showList, batchId, selectedLender, sortOrder, sortBy, dataExport, responseType }) {
    if (showList) {
      return this.get(
        `${config.baseUrl["admin"]}/co-lender/da/get-leads-by-batch/${batchId}?assignLender=${selectedLender}&status_ids=6${sortOrder ? `&sort_order=${sortOrder}` : ""
        }${sortBy ? `&sort_by=${sortBy}` : ""}${dataExport ? `&export=${dataExport}` : ''}`, null, responseType);
    } else {
      return this.get(
        `${config.baseUrl["admin"]}/co-lender/da/get-leads-by-batch/${batchId}`)
    }
  }
  static getBAtchListOfPoolAssignment({ batchId, page, sortOrder, sortBy, dataExport, responseType }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/get-leads-by-batch/${batchId}?page=${page}${sortOrder ? `&sort_order=${sortOrder}` : ""
      }${sortBy ? `&sort_by=${sortBy}` : ""}${dataExport ? `&export=${dataExport}` : ''}`, null, responseType);
  }
  static submitBatchToLender(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/assign-batch`, payloadData);
  }
  static getDaDecisionPendingList({ per_page, page }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/decision-pending-batch-list?per_page=${per_page}&page=${page}`);
  }
  static getPreApprovedDaBatchList({ batchid, selectedLender, page, sortOrder, sortBy, dataExport, responseType }) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/get-leads-by-batch/${batchid}?assignLender=${selectedLender}&status_ids=4,5,6,7&page=${page}${sortOrder ? `&sort_order=${sortOrder}` : ""
      }${sortBy ? `&sort_by=${sortBy}` : ""}${dataExport ? `&export=${dataExport}` : ''}`, null, responseType);
  }
  static getApprovedLendersList(batchId) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/assigned-lender-list/${batchId}`);
  }
  static submitDaLeadsToLender(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/save-final-approved-lead`, payloadData
    );
  }
  static getFinalApprovedList() {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/da-final-batch-list`
    );
  }
  static getSubIndustryList(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/mst-list-prod-prop`, payloadData
    );
  }
  static getSubPropertyTypeList(payloadData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/da/mst-list-prod-prop`, payloadData
    );
  }
  static getLendersList(batchId) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/lender-list/${batchId}`
    );
  }
  static getLenderStatusByBatchId(batchId) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/da/decision-status/${batchId}`
    );
  }

  static getDoaList({
    type,
    leadType,
    page,
    dataExport,
    queryParams,
    responseType,
    sortOrder,
    sortBy,
    isOps,
    per_page
  }) {
    return this.get(
      `${config.baseUrl[type]}/${isOps ? "ops" : "co-lender"
      }/leads/doa-list?page=${page}&per_page=${per_page}&export=${dataExport}&${queryParams}${sortOrder ? `&sort_order=${sortOrder}` : ""
      }${sortBy ? `&sort_by=${sortBy}` : ""}&lead_type=2`,
      null,
      responseType
    );
  }
  static finalDoaSubmit(payloadData) {
    return this.post(`${config.baseUrl['admin']}/co-lender/lead/submit-to-doa`, payloadData);
  }
  static changeApiLogStatus({ type, id, cl_lender_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/change-api-log-status/${cl_lender_id}/${id}`);
  }
  static saveAdditionalInfoAbbData({ type, leadId, cl_lender_id, payloadData, AssessmentType }) {
    return this.post(`${config.baseUrl[type]}/co-lender/lead/save-additional-info-cta?lender_id=${cl_lender_id}&cl_lead_id=${leadId}&assessment_type=${AssessmentType}`, payloadData);
  }
  static getAdditionalInfoAbbData({ type, add_info_cta_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/lead/get-additional-info-cta?add_info_cta_id=${add_info_cta_id}`);
  }
  /** Get/Add trancg at 10-06-2026 **/
  static saveAdditionalInfoTranchData({ type, leadId, cl_lender_id, payloadData }) {
    return this.post(`${config.baseUrl[type]}/co-lender/lead/save-additional-info-trnch?lender_id=${cl_lender_id}&cl_lead_id=${leadId}`, payloadData);
  }
  static getAdditionalInfoTranchData({ type, add_info_trnch_id, leadId, cl_lender_id}) {
    return this.get(`${config.baseUrl[type]}/co-lender/lead/get-additional-info-trnch?lender_id=${cl_lender_id}&cl_lead_id=${leadId}&add_info_trnch_id=${add_info_trnch_id}`);
  }
  /** Get/Add trancg at 10-06-2026 end **/
  static getPayToCustomerDetails({ type, leadId, paytype }) {
    return this.get(`${config.baseUrl[type]}/co-lender/lead/${paytype}/${leadId}`);
  }
  static savePayToCustomerData(payloadData) {
    return this.post(`${config.baseUrl['admin']}/co-lender/lead/paytocustomer/submit`, payloadData);
  }
  static convertClmtype(payloadData) {
    return this.post(`${config.baseUrl['admin']}/co-lender/lead/option1to2`, payloadData);
  }
  static downloadAddInfoFile({ fileId, fileType, responseType, lenderId=null }) {
    let type = (fileType == 'utr' ? 'fundoutfile' : (fileType == 'collection' ? 'collection' : 'file'))
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/download/excel?type=${type}&file_id=${fileId}&lenderId=${lenderId}`,
      null,
      responseType
    );
  }
  static downloadLogFile({ fileUrl, fileType, responseType, lenderId=null }) {
    let type = (fileType == 'collection') ? 'collection-logs' : '';
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/download/excel?type=${type}&file_url=${fileUrl}&lenderId=${lenderId}`,
      null,
      responseType
    );
  }
  static getCollectionsList({type, page, dataExport, queryParams, responseType}) {
    return this.get(
      `${config.baseUrl[type]}/ops/leads/disbursal-approved?page=${page}&export=${dataExport}&${queryParams}`,
      null,
      responseType
    );
  }
  static getCollectionsData({type, leadId, cl_lender_id, responseType}) {
    return this.get(
      `${config.baseUrl[type]}/co-lender/lead/get-collections/${leadId}/${cl_lender_id}`,
      null,
      responseType
    );
  }
  static saveCollectionsData({type, payloadData}) {
    return this.post(`${config.baseUrl[type]}/co-lender/lead/save-collections`, payloadData);
  }
  static getCollectionsPrefilledData({type, leadId, cl_lender_id, payment_mode, pay_to, responseType}) {
    return this.get(
      `${config.baseUrl[type]}/co-lender/lead/get-collections-prefill-data?cl_lead_id=${leadId}&cl_lender_id=${cl_lender_id}&payment_mode=${payment_mode}&payTo=${pay_to}`,
      null,
      responseType
    );
  }
  static getLenderCollections({ type, cl_lead_id, cl_lender_id }) {
    return this.get(
      `${config.baseUrl[type]}/co-lender/lead/get-lender-collections/${cl_lead_id}/${cl_lender_id}`,
      null
    );
  }
  static getLenderCollectionLogs({logsPage, heading}) {
    return this.get(
      `${config.baseUrl["admin"]}/co-lender/lead/${heading}/uco-api-logs-data?page=${logsPage}`
    );
  }
  static submitCgPanInfo(formData) {
    return this.post(
      `${config.baseUrl["admin"]}/co-lender/lead/save-doa-additional-info`,
      formData
    );
  }
  static downloadCaseFile({ case_id }) {
    return this.get(
      `${config.baseUrl['admin']}/co-lender/logs/download-api-log-file?log_id=${case_id}`,
      null,
      "blob"
    );
  }

  static getColendingLogList({ type, lender_id, laf_id, lead_id, application_id, lead_type, assigned_date_from, assigned_date_to, created_date_from, created_date_to, response_status, los_source, page }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/colending-response-list?lender_id=${lender_id}${laf_id ? `&laf_id=${laf_id}` : ''}${lead_id ? `&lead_id=${lead_id}` : ''}${application_id ? `&application_id=${application_id}` : ''}${lead_type ? `&lead_type=${lead_type}` : ''}${assigned_date_from ? `&assigned_date_from=${assigned_date_from}` : ''}${assigned_date_to ? `&assigned_date_to=${assigned_date_to}` : ''}${created_date_from ? `&created_date_from=${created_date_from}` : ''}${created_date_to ? `&created_date_to=${created_date_to}` : ''}${response_status ? `&response_status=${response_status}` : ''}${los_source ? `&los_source=${los_source}` : ''}&page=${page}`);
  }

  static getStatusColendinglogs({ type, cl_lead_id, cl_lender_id }) {
    return this.get(`${config.baseUrl[type]}/co-lender/logs/colending-refetch-status/${cl_lead_id}/${cl_lender_id}`);
  }
}